// extracted by mini-css-extract-plugin
module.exports = {"notice":"notice_notice__UYt3w"};